import React from 'react';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTicketAlt } from '@fortawesome/free-solid-svg-icons';
import { renderVenueBadge, renderSectionBadge, renderItemPriceDetail, renderSeatInfo } from './ticketHelpers';

export function OrderItemList({ order, totalsOnly = false, hideCodes = false }) {
    function renderQrCode(code) {
        const qrcode = code.qrcode;
        const darkColor = '000000';
        switch(code.ticket_type) {
            case 'VENUE_OPEN':
            case 'VENUE_SEAT':
            case 'VENUE_TABLE_SEAT':
                return <><img src={`https://devapi.viveloonline.com/etickets/qr?str=${qrcode}&d=${darkColor}`} width="200" height="200" /><br/><span className="code" style={{width:200,display:'inline-block',marginRight:10,padding:0,textAlign:'center'}}>{code.code.split('-')[1]}</span></>;
            default:
                return <>Código: <span className="code">{code.code.split('-')[1]}</span></>;
        }
    }

    let items = order ? order.tickets || [] : [];
    let ticketsTotal = 0;
    let feeTotal = 0;
    const tickets = items.map(t => {
        ticketsTotal += t.total_price || 0;
        feeTotal += t.total_fee || 0;
        const codes = order.codes.filter(c => c.order_ticket_uid === t._id);
        return !totalsOnly ? (
            <div className="cart-item cart-item-ticket cart-item-card" key={t._id}>
                <div className="cart-item-info">
                    <div className="cart-item-image">
                        <img src={t.image || '/img/placeholder.png'} alt="event" />
                    </div>
                    <div>
                        <div className="cart-item-badges">
                            {renderVenueBadge(t)}
                            {renderSectionBadge(t)}
                        </div>
                        <div className="cart-item-title cart-item-title-large">{t.title}</div>
                        <div className="cart-item-date">{t.show_date ? moment(t.show_date).locale('es').format('ddd, D [de] MMMM [de] YYYY - HH:mm') : ''}</div>
                        <div className="cart-item-ticket-type"><FontAwesomeIcon icon={faTicketAlt} style={{marginRight: 6}} />{t.description}</div>
                        <div className="cart-item-seat-info">{renderSeatInfo(t)}</div>
                        <div className="cart-item-description cart-item-access-note">
                            {t.note ? t.note : 'Acceso presencial. Presenta el código QR en la entrada del evento.'}
                        </div>
                        { t.bundle_items && (
                            <div className="cart-item-bundle-info">
                                { t.bundle_items.map((item, idx) => (
                                    <div key={idx}>• {item.quantity} x {item.description}</div>
                                )) }
                            </div>
                        ) }
                        <div className="cart-item-numbers">
                            <div></div>
                            <div className="cart-item-price cart-item-price-bold">{renderItemPriceDetail(order, t)}</div>
                            {/* {!t.fee_included && <div className="cart-item-fee">Servicio: {t.quantity} x +{t.fee ? t.fee.toFixed(2) : ''}</div>} */}
                        </div>
                        <div className="cart-item-ticketbox">
                            <div className="cart-item-ticketlist">
                                {order.status === 'APPROVED' && codes.length > 0 ? (
                                    codes.map((c, idx) => (
                                        <div className="ticket" key={c._id}>
                                            {renderQrCode(c)}
                                        </div>
                                    ))
                                ) : (
                                    <div className="ticket">Tus códigos aún se están generando. <a href="#" className="code" onClick={() => window.location.reload()}>RECARGAR</a></div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        ) : null;
    });
    return <div className="cart-item-group order-item-list">
        {tickets}
    </div>;
} 